import * as React from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";

export const SUCCESS_EVENT_TYPE = "lazyload:success";
export const ERROR_EVENT_TYPE = "lazyload:error";

interface Props {
  options: Omit<IntersectionObserverInit, "root"> & {
    rootId?: string;
  };
}

class LazyImageContextProvider extends React.PureComponent<Props> {
  public static childContextTypes = {
    getLazyImageIntersectionObserver: PropTypes.func,
  };

  private lazyImageIntersectionObserver?: IntersectionObserver;
  private browser = detect();

  public componentWillUnmount() {
    this.getLazyImageIntersectionObserver()!.disconnect();
  }

  public getChildContext() {
    return {
      getLazyImageIntersectionObserver: this.getLazyImageIntersectionObserver,
    };
  }

  public getLazyImageIntersectionObserver = () => {
    if (this.lazyImageIntersectionObserver) {
      return this.lazyImageIntersectionObserver;
    }
    const { rootId, ...options } = this.props.options;
    if (rootId) {
      (options as any).root = document.getElementById(rootId);
    }
    this.lazyImageIntersectionObserver = new IntersectionObserver(this.handleObserver, options);
    return this.lazyImageIntersectionObserver;
  };

  public handleObserver: IntersectionObserverCallback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.lazyImageIntersectionObserver!.unobserve(entry.target);
        const src = entry.target.getAttribute("data-src");
        const image = new Image();
        image.onload = () => {
          let event: Event;
          if (this.browser && this.browser.name === "ie") {
            event = document.createEvent("Event");
            event.initEvent(SUCCESS_EVENT_TYPE, true, true);
          } else {
            event = new Event(SUCCESS_EVENT_TYPE);
          }
          entry.target.dispatchEvent(event);
        };
        image.onerror = () => {
          let event: Event;
          if (this.browser && this.browser.name === "ie") {
            event = document.createEvent("Event");
            event.initEvent(ERROR_EVENT_TYPE, true, true);
          } else {
            event = new Event(ERROR_EVENT_TYPE);
          }
          entry.target.dispatchEvent(event);
        };
        image.src = src!;
      }
    });
  };

  public render() {
    return this.props.children;
  }
}

export default LazyImageContextProvider;



// WEBPACK FOOTER //
// ./frontend/src/common/components/lazy/LazyImageContextProvider.tsx